import React from 'react';
import { Typography } from 'src/components';

const MultipleLinksMessage: React.FC = () => (
  <div className="flex justify-center items-center bg-neutral-050 rounded-md p-2">
    <Typography className="text-tertiary text-sm text-center px-2">
      We are unable to load all CRM fields when there are multiple records for a
      single CRM object.
    </Typography>
  </div>
);

export default MultipleLinksMessage;
